import { ONE_DAY_MS } from '../../common/constants/time';
export const toQuarter = (date) => Math.floor(date.getUTCMonth() / 3);
export const computePresentDuties = (lines, subLines) => {
    const daysOff = lines.filter((s) => s.daysOff !== null && s.daysOff > 0);
    const allDates = [];
    daysOff.forEach((dayOffLine) => {
        const firstDayOff = new Date(dayOffLine.subLines[0].date);
        firstDayOff.setUTCHours(12, 0, 0, 0);
        for (let day = 0; day < dayOffLine.daysOff; ++day) {
            allDates.push(new Date(firstDayOff.getTime() + ONE_DAY_MS * day));
        }
    });
    subLines.forEach((subline) => {
        const sublineDate = subline.date;
        const daysSameQuarter = allDates.filter((d) => d.getUTCFullYear() === sublineDate.getUTCFullYear() && toQuarter(d) === toQuarter(sublineDate));
        subline.daysOffCalendarQuarterCount = daysSameQuarter.length;
        subline.daysOffCalendarMonthCount = daysSameQuarter.filter((d) => d.getUTCMonth() === sublineDate.getUTCMonth()).length;
    });
};
export const computeFutureDuties = (subLines) => {
    if (!subLines.length) {
        return;
    }
    const latestSubLine = subLines[0];
    const latestSubLineDate = new Date(latestSubLine.date);
    latestSubLineDate.setUTCHours(12, 0, 0, 0);
    const latestYear = latestSubLineDate.getUTCFullYear();
    const latestMonth = latestSubLineDate.getUTCMonth();
    const endMonthDate = new Date(latestSubLineDate);
    endMonthDate.setUTCMonth(latestMonth + 1, 1);
    endMonthDate.setUTCHours(-12, 0, 0, 0);
    const daysTillEndOfMonth = Math.round((endMonthDate.getTime() - latestSubLineDate.getTime()) / ONE_DAY_MS);
    const latestQuarter = Math.floor(latestMonth / 3);
    const endQuarterDate = new Date(latestSubLineDate);
    endQuarterDate.setUTCMonth((latestQuarter + 1) * 3, 1);
    endQuarterDate.setUTCHours(-12, 0, 0, 0);
    const daysTillEndOfQuarter = Math.round((endQuarterDate.getTime() - latestSubLineDate.getTime()) / ONE_DAY_MS);
    for (const subline of subLines) {
        if (subline.date.getUTCFullYear() === latestYear && toQuarter(subline.date) === latestQuarter) {
            subline.daysOffCalendarQuarterCount += daysTillEndOfQuarter;
            if (subline.date.getUTCMonth() === latestMonth) {
                subline.daysOffCalendarMonthCount += daysTillEndOfMonth;
            }
        }
        else {
            break;
        }
    }
};
export const computePastDuties = (subLines) => {
    if (!subLines.length) {
        return;
    }
    const earliestSubLine = subLines.at(-1);
    const earliestSubLineDate = new Date(earliestSubLine.date);
    earliestSubLineDate.setUTCHours(12, 0, 0, 0);
    const earliestYear = earliestSubLineDate.getUTCFullYear();
    const earliestMonth = earliestSubLineDate.getUTCMonth();
    const startMonthDate = new Date(earliestSubLineDate);
    startMonthDate.setUTCMonth(earliestMonth, 1);
    startMonthDate.setUTCHours(12, 0, 0, 0);
    const daysSinceStartOfMonth = Math.round((earliestSubLineDate.getTime() - startMonthDate.getTime()) / ONE_DAY_MS);
    const earliestQuarter = Math.floor(earliestMonth / 3);
    const startQuarterDate = new Date(earliestSubLineDate);
    startQuarterDate.setUTCMonth(earliestQuarter * 3, 1);
    startQuarterDate.setUTCHours(12, 0, 0, 0);
    const daysSinceStartOfQuarter = Math.round((earliestSubLineDate.getTime() - startQuarterDate.getTime()) / ONE_DAY_MS);
    for (let i = subLines.length - 1; i >= 0; --i) {
        const subline = subLines[i];
        if (subline.date.getUTCFullYear() === earliestYear && toQuarter(subline.date) === earliestQuarter) {
            subline.daysOffCalendarQuarterCount += daysSinceStartOfQuarter;
            if (subline.date.getUTCMonth() === earliestMonth) {
                subline.daysOffCalendarMonthCount += daysSinceStartOfMonth;
            }
        }
        else {
            break;
        }
    }
};
export const computeAllDaysOffSums = (lines, subLines) => {
    computePresentDuties(lines, subLines);
    computeFutureDuties(subLines);
    computePastDuties(subLines);
};
//# sourceMappingURL=computeAllDaysOffSums.js.map